export default __webpack_public_path__ + "static/media/face15.00f72a57.jpg";